import { Card, CardHeader, CardText } from 'material-ui/Card';
import { deletePatientGuardianDetails, getPatientByTag, getPatientGuardianList, getPatientMasterData } from '../../actions/PatientActions';
import React, { Component } from 'react';
import Alert from 'react-s-alert';
import { CommonButton } from '../../../../components/buttons';
import { connect } from 'react-redux';
import PatientGuardianModal from './patient_guardian_form';
import { alertConfirmation } from '../../../../actions/utilAction';

class PatientGuardian extends Component {
  constructor(props) {
    super(props);
    this.state = ({
      open: false,
      patient_id: props.patient_id,
      patientMasterData: [],
      guardianId: null,
    });

  }
  componentWillMount() {
    let masterData = {
      'masterdata': 'MASTERRELATIONSHIP',
    };
    this.props.getPatientMasterData(masterData);
    if (this.state.patient_id) {
      this.loadData(this.state.patient_id);
    };
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.patientMasterData && this.props.patientMasterData !== nextProps.patientMasterData) {
      this.setState({
        patientMasterData: nextProps.patientMasterData,
      });
    }
    if (nextProps.patientGuardianAdded && this.props.patientGuardianAdded !== nextProps.patientGuardianAdded) {
      this.loadData(nextProps.patient_id);
    }

    if (nextProps.patientGuardianDeleted && this.props.patientGuardianDeleted !== nextProps.patientGuardianDeleted) {
      this.loadData(nextProps.patient_id);
    }

    if (nextProps.patient_id && this.props.patient_id !== nextProps.patient_id) {
      this.loadData(nextProps.patient_id);
    }

  }

  loadData(patient_id) {
    let searchObj = {
      contain_filters: { PatientId: patient_id ? patient_id : this.state.patient_id },
      // includes: 'include=masterrelationship',
    };
    this.props.getPatientGuardianList(searchObj);
  }

  handleOpen = () => {
    Alert.closeAll();
    this.setState({ open: true, guardianId: null });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
    // this.loadData(this.props.patient_id);
  };

  handleEditClick = (event, guardianObject) => {
    Alert.closeAll();
    this.setState({ open: true, guardianId: guardianObject.id });

  };

  handlePatientTabChange = () => {
    this.props.handlePatientTabChange('2');
    Alert.closeAll();
  };
  componentWillUnmount() {
    Alert.closeAll();
  }

  handleAlertClick = (event, guardian_id) => {
    this.props.deletePatientGuardianDetails(guardian_id);
    Alert.closeAll();
  };

  handleDeleteClick = (event, guardianObject) => {
    alertConfirmation('Are you sure you want to delete parent/guardian ?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: guardianObject.id,
      },
    });
  };

  renderCards = () => {
    if (this.props.patientGuardianList && this.props.patientGuardianList.data && this.props.patientGuardianList.data.length >= 0) {
      return (
        this.props.patientGuardianList.data.map((guardianObj, index) => {
          let relationshipName = (guardianObj.relationshipName || '').toLowerCase() === 'other' ?
            `${guardianObj.relationshipName} (${guardianObj.otherRelationshipName})` : guardianObj.relationshipName;
          return (
            <div className="col-sm-6 history_card mt20 mb10" key={index}>
              <Card>
                <div className="cardactbtn">
                  <button onClick={(e) => this.handleEditClick(e, guardianObj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                  <button onClick={(e) => this.handleDeleteClick(e, guardianObj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                </div>
                <CardHeader className="cardheader"
                  title={`${guardianObj.guardianFirstName} ${guardianObj.guardianMiddleName ? guardianObj.guardianMiddleName : ''} ${guardianObj.guardianLastName}`}
                  actAsExpander={false}
                  showExpandableButton={false}
                />
                <div>
                  <div className= "familydl itemalign">
                    <ul>
                      <span className="ltrcont">
                        <li>Relation : <span>{relationshipName || '-'}</span></li>
                        <li>Phone : <span>{guardianObj.guardianHomePhone ? guardianObj.guardianHomePhone : '-'}</span></li>
                        <li>Email : <span>{guardianObj.guardianEmail || '-'}</span></li>
                      </span>
                    </ul>
                  </div>
                </div>
                <div className="clearfix"></div>
                <CardText className="disascontent" expandable={false}>
                </CardText>
              </Card>
            </div>
          );
        }
        ));
    } else {
      return (<div className="col-sm-12 history_card mt20">
        <div className="familydl text-center no-record">
          No record found.
        </div>
      </div>);
    }

  }

  render() {
    return (
      <div>
        {this.state.open ?
          <PatientGuardianModal patientMasterData={this.state.patientMasterData} closeDialog={this.handleClose} patient_id={this.state.patient_id} guardianId={this.state.guardianId} /> : null
        }
        <CommonButton label="Add Guardian/Guarantor" primary={true} onTouchTap={this.handleOpen} />
        <div className="row">
          {this.renderCards()}
          <div className="col-sm-12 pt20 btn_rt">
            <CommonButton label="Continue" primary={true} onTouchTap={this.handlePatientTabChange} />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    patientMasterData: state.patient.patientMasterData,
    patientGuardianList: state.patient.patientGuardianList,
    patientGuardianAdded: state.patient.saved_patientGuardianDetails,
    patientGuardianDeleted: state.patient.deleted_patientGuardianDetails,

  };
}

export default connect(mapStateToProps, { deletePatientGuardianDetails, getPatientMasterData, getPatientGuardianList, getPatientByTag })(PatientGuardian);



// WEBPACK FOOTER //
// ./src/modules/patients/components/guardian/patient_guardian.js